export default __webpack_public_path__ + "fe59c8328d017a704aee895edc6c2e39.png";